import React, { useState } from "react";
import "./Handelaars.css";

import { useWindowSize } from "./hooks/useWindowSize";
import axios from "axios";

import { Handelaar } from "./Handelaar";
import { LeafMap } from "./Map";
import { SearchComponent } from "./SearchComponent";
import { CardList } from "./CardList";
import { Card } from "@material-ui/core";

import _ from "lodash";

export async function fetchData() {
  const res = await axios.get(
    "https://deborre-api.herokuapp.com/handelaars?_limit=250"
  );

  const parsedResult = res.data
    .map((x) => new Handelaar(x))
    .sort((h_a, h_b) => h_a.place.localeCompare(h_b.place));

  return parsedResult;
}

const Handelaars = () => {
  const [filteredIndices, setFilteredIndices] = useState([]);
  const [filteredIndicesCat, setFilteredIndicesCat] = useState([]);
  const [handelaars, setHandelaars] = useState([]);
  const [modalHandelaar, setModalHandelaar] = useState(-1);
  const [zoomLocation, setZoomLocation] = useState(null);
  const [searchOpen, setSearchOpen] = useState(false);

  const size = useWindowSize();

  React.useEffect(() => {
    try {
      fetchData().then((data) => {
        setHandelaars(data);
      });
    } catch (e) {
      // do nothing :)
    }
  }, []);

  const handleChange = (e) => {
    let tempIndices = [];
    handelaars.forEach((handelaar, i) => {
      if (!handelaar.containsInAField(e.target.value)) {
        tempIndices.push(i);
      }
    });
    setFilteredIndices(tempIndices);
  };

  const filterHandelaars = (gemeentes) => {
    let tempIndices = [];
    if (gemeentes.length > 0) {
      //this means one or more gemeentes are selected
      handelaars.forEach((handelaar, i) => {
        if (!gemeentes.includes(handelaar?.mainPlace?.toLowerCase())) {
          tempIndices.push(i);
        }
      });
    }
    setFilteredIndices(tempIndices);
  };

  // this function should of have been generalised
  // see above
  const filterHandelaarsCategories = (categories) => {
    let tempIndices = [];

    if (categories.length > 0) {
      //this means one or more gemeentes are selected
      handelaars.forEach((handelaar, i) => {
        console.log(
          _.flatten(handelaar?.categories.map((cat) => cat.naam)).map((naam) =>
            naam.toLowerCase()
          )
        );

        if (
          !categories.some((cat) =>
            _.flatten(handelaar?.categories.map((cat) => cat.naam))
              .map((naam) => naam.toLowerCase())
              .includes(cat)
          )
        ) {
          tempIndices.push(i);
        }
      });
    }
    setFilteredIndicesCat(tempIndices);
  };

  const cards = (
    <CardList
      filteredIndices={_.uniq([...filteredIndices, ...filteredIndicesCat])}
      handelaars={handelaars}
      modalHandelaar={modalHandelaar}
      setModalHandelaar={setModalHandelaar}
      setZoomLocation={setZoomLocation}
      setSearchOpen={setSearchOpen}
    />
  );

  const leafMap = (
    <LeafMap
      handelaars={handelaars}
      setModalHandelaar={setModalHandelaar}
      lat={zoomLocation ? zoomLocation.lat : 50.827395}
      lng={zoomLocation ? zoomLocation.lng : 4.752906}
      zoom={zoomLocation ? zoomLocation.zoom : 12}
      minZoom={11}
    />
  );

  if (size.width > 900) {
    return (
      <>
        <div style={{ width: 350, height: "100vh", overflow: "auto" }}>
          <div style={{ padding: "30px" }}>
            <SearchComponent
              filter
              onFilter={filterHandelaars}
              gemeentes={_.uniq(
                handelaars.map((h) => h.mainPlace?.toLowerCase())
              )}
              categories={_.uniq(
                _.flatten(handelaars.map((h) => h.categories)).map((cat) =>
                  cat.naam.toLowerCase()
                )
              )}
              onFilterCategorie={filterHandelaarsCategories}
              handleChange={handleChange}
            />
            {cards}
          </div>
        </div>
        {leafMap}
      </>
    );
  } else {
    return (
      <div>
        <div style={{ paddingLeft: 8 }}>
          <SearchComponent
            handleChange={handleChange}
            onClick={() => {
              setSearchOpen(true);
            }}
          />
        </div>

        <Card
          style={{
            display: searchOpen ? "block" : "none",
            position: "fixed",
            top: 80,
            left: "calc((100% - 300px) / 2)",
            zIndex: 2,
            width: 300,
            marginLeft: "auto",
            marginRight: "auto",
            overflow: "auto",
            height: "calc(100% - 60px - 50px)",
          }}
        >
          <button
            style={{
              position: "fixed",
              right: "calc(((100% - 300px) / 2) + 10px)",
              zIndex: 5,
              marginTop: 10,
            }}
            onClick={() => setSearchOpen(false)}
          >
            X
          </button>
          <div
            style={{
              padding: "0 16px",
              minHeight: 64,
            }}
          >
            {cards}
          </div>
        </Card>

        {leafMap}
      </div>
    );
  }
};

export default Handelaars;
